<div class="calendar-container border animate__animated animate__fadeIn position-relative">

  <!-- Calendar Navigation & View Select Toolbar -->
  <div class="calendar-nav d-flex align-items-center justify-content-center position-relative mb-4" style="min-height: 40px;">

    <!-- Left: prev / next buttons -->
    <div class="position-absolute h-100 d-flex align-items-center" style="left: 0; gap: 8px; z-index: 10;">
      <button type="button" class="calendar-nav__btn" (click)="prev()" aria-label="Previous">
        <i class="fa fa-chevron-left"></i>
      </button>
      <button type="button" class="calendar-nav__btn" (click)="next()" aria-label="Next">
        <i class="fa fa-chevron-right"></i>
      </button>
    </div>

    <!-- Center: current month/period title -->
    <h4 class="m-0 font-weight-bold text-dark month-year-title text-center">
      {{ currentTitle() }}
    </h4>

    <!-- Right: view selector dropdown -->
    <div class="position-absolute h-100 d-flex align-items-center" style="right: 0; z-index: 10;">
      <app-calendar-view-select [currentView]="currentView" (viewChange)="onViewChange($event)">
      </app-calendar-view-select>
    </div>
  </div>

  <!-- ── Month view: custom HTML grid ──────────────────────────────── -->
  @if (currentView === 'dayGridMonth') {
    <div class="calendar-wrapper">
      <div class="calendar-grid">

        <!-- Weekday headers -->
        @for (day of weekdays; track day) {
          <div class="calendar-grid__weekday text-uppercase font-weight-bold text-muted small text-center py-2">
            {{ day }}
          </div>
        }

        <!-- Day cells -->
        @for (day of calendarDays(); track day.date.toISOString()) {
          <div
            class="calendar-grid__day"
            [class.calendar-grid__day--other-month]="!day.isCurrentMonth"
            [class.calendar-grid__day--today]="day.isToday"
          >
            <div class="day-number-label">{{ day.dayNumber }}</div>

            <!-- Order badges (max 3 visible) -->
            <div class="day-orders-list d-flex flex-column gap-1">
              @for (order of day.orders.slice(0, 3); track order.ident_order) {
                <button
                  type="button"
                  class="order-event-badge text-start border-0 px-2 py-1 rounded text-truncate"
                  [style.borderLeftColor]="getStatusColor(order)"
                  [title]="(order.name_client_address || order.ident_order) + ' – ' + order.status"
                  (click)="openDetail(order, $event)"
                >
                  <span class="status-dot-indicator" [style.backgroundColor]="getStatusColor(order)"></span>
                  <span class="client-name-text">{{ order.name_client_address || '—' }}</span>
                </button>
              }

              @if (day.orders.length > 3) {
                <span class="more-orders-indicator small font-weight-bold text-muted ps-2">
                  +{{ day.orders.length - 3 }} more
                </span>
              }
            </div>
          </div>
        }
      </div>

      <!-- Loading overlay -->
      @if (isLoading()) {
        <div class="calendar-loading-overlay d-flex align-items-center justify-content-center">
          <div class="spinner-border text-primary" style="width:2rem;height:2rem;" role="status">
            <span class="visually-hidden">Loading…</span>
          </div>
        </div>
      }
    </div>
  } @else {
    <!-- ── FullCalendar (week / day / list views) ──────────────────── -->
    <full-calendar #calendar [options]="calendarOptions"></full-calendar>
  }

</div>
